var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLabel = function SvgLabel(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.175 13.15-3.525 5a1.9 1.9 0 0 1-.712.625A2 2 0 0 1 15 19H5q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 17V7q0-.824.587-1.412A1.93 1.93 0 0 1 5 5h10q.5 0 .938.225t.712.625l3.525 5q.375.525.375 1.15t-.375 1.15M15 17l3.55-5L15 7H5v10z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLabel);
export { ForwardRef as ReactComponent };